import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=0c8a8b53&scoped=true"
import script from "./Area.vue?vue&type=script&lang=js"
export * from "./Area.vue?vue&type=script&lang=js"
import style0 from "./Area.vue?vue&type=style&index=0&id=0c8a8b53&prod&lang=scss&scoped=true"
import style1 from "./Area.vue?vue&type=style&index=1&id=0c8a8b53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a8b53",
  null
  
)

export default component.exports